module.exports = __webpack_public_path__ + "img/Crear Clase Icono.662f14ec.svg";